import React, { useState, useRef, useEffect } from "react";
import { useLanguage } from "./LanguageContext";

const languages = [
  { code: "de", label: "Deutsch", flag: "/flags/de.svg" },
  { code: "en", label: "English", flag: "/flags/en.svg" },
];

export default function LanguageSelector() {
  const { lang: language, setLang: setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Klick außerhalb schließt Dropdown
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentLang = languages.find((l) => l.code === language);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      {/* Aktuelle Sprache */}
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 p-2 border rounded cursor-pointer"
      >
        <img src={currentLang.flag} alt={currentLang.label} className="w-5 h-5" />
        <span>{currentLang.label}</span>
      </button>

      {/* Dropdown-Liste */}
      {open && (
        <div className="absolute mt-1 border rounded bg-white shadow-lg z-50 w-max">
          {languages.map((lang) => (
            <div
              key={lang.code}
              onClick={() => {
                setLanguage(lang.code); // <-- hier war der Fehler
                setOpen(false);
              }}
              className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer"
            >
              <img src={lang.flag} alt={lang.label} className="w-5 h-5" />
              <span>{lang.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
